<!--
  @component
  Generates an SVG multi-series line chart. It expects your data to be an array of objects, each with a `values` key that is an array of data objects.
 -->
 <script>
  import { draw, fade } from 'svelte/transition';
  import { tweened } from 'svelte/motion';
  import { cubicOut, quintOut } from 'svelte/easing';
  import { getContext } from 'svelte';
  import { interpolateString } from 'd3-interpolate';

  export let pointData;
  export let lineDrawDuration;
  export let color;
  export let highlight;
  export let isLast;


  const { xScale, yScale, zGet, yGet, xGet, zDomain, zRange, width } = getContext('LayerCake');

  const animationParameters = {
   duration: 300,
  //  easing: quintOut,
   delay: 0,
  };

  let tX = tweened($xGet(pointData), animationParameters);
  $: targetX = $xGet(pointData);
  $: tX.set(targetX, animationParameters);

  let tY = tweened($yGet(pointData), animationParameters);
  $: targetY = $yGet(pointData);
  $: tY.set(targetY, animationParameters);

  // let d = tweened(null, { interpolate: interpolateString });

</script>

<circle
  style="--theme-color: {color}"
  in:fade="{{duration: 100, delay: lineDrawDuration, ease: quintOut }}"
  class='point'
  class:highlight={highlight}
  class:last={isLast}
  fill="{highlight ? "#BBC9D9" : color}"
  cx={$tX}
  cy={$tY}
  r={$width > 544 ? 3 : 1.5}
/>

<style lang="scss">
  .point {
    stroke: none;

    &.highlight {
      stroke: #BBC9D9;
      stroke-width: 1px;
      filter: drop-shadow(0px 0px 6px #BBC9D9);
    }

    &.last {
      stroke: #211c46;
      stroke-width: 1px;
      filter: drop-shadow(0px 0px 6px var(--theme-color));

    }
  }
</style>